import React from 'react'
import { PaletteColor, SxProps } from '@mui/material'

export enum ExtensionStates {
  Active = 'active',
  Pending = 'pending',
}

export type ExtensionState = `${ExtensionStates}`

export enum ExtensionTypes {
  LuoxOne = 'luoxDirectMarketing',
  LuoxTwo = 'luox',
  OStrom = 'ostrom',
  Inexogy = 'inexogy',
  Tibber = 'tibber',
  Eon = 'eon',
  Ai360PowerShare = 'ai360PowerShare',
  Ai360PowerFix = 'ai360PowerFix',
}

export type ExtensionType = `${ExtensionTypes}`

/* Note: The names are used as part of dynamic translation keys. If you adjust them here new t-keys need to be added */
export type ExtensionCategoryName = `${ExtensionCategoryNames}`

export enum ExtensionCategoryNames {
  DirectMarketing = 'direct-marketing',
  DynamicEnergyTariff = 'dynamic-energy-tariff',
  SmartMeter = 'smart-meter',
  ElectricityTariffAddOn = 'electricity-tariff-add-on',
  ProsumerTariff = 'prosumer-tariff',
}

export interface ExtensionCategory {
  name: ExtensionCategoryName
  paletteColor: PaletteColor
  variant?: 'main' | 'light' | 'dark'
}
export interface Extension {
  name: string
  category: ExtensionCategory
  logo: React.ReactElement
  contractState?: ExtensionState
  onClick: () => void
  isVisible: boolean
  isLoading: boolean
  /** Whether the extension is ready to use or shown in the 'Coming soon' section */
  isAvailable: boolean
}

export interface ExtensionDetailsProps {
  extensionState?: ExtensionState
  hasActiveTariff?: boolean
  isLoading?: boolean
  onClose: () => void
  place?: number
  loadInstallationExtensionStates: () => Promise<void>
}

export interface ExtensionDeleteConnectionModalProps {
  onClose: () => void
  loadInstallationExtensionStates: () => Promise<void>
  place?: number
}

/**
 * The two ai360 tariffs that can trigger the smart meter recommendation, and that ContinueAi360TariffOrderBanner needs
 * to remember in order to reopen the right details modal.
 */
export type Ai360SmartMeterTariffType = ExtensionTypes.Ai360PowerFix | ExtensionTypes.Ai360PowerShare

export interface SmartMeterRecommendationModalProps {
  onClose: () => void
  onContinue: () => void
  tariffType: Ai360SmartMeterTariffType
  place?: number
}

export enum ExtensionConnectionTypes {
  Ostrom = 'ostrom',
  Tibber = 'tibber',
  Luox = 'luox',
  Ai360PowerShare = 'ai360PowerShare',
  Ai360PowerFix = 'ai360PowerFix',
}

export type ExtensionConnectionType = `${ExtensionConnectionTypes}`

export interface ContractStateProps {
  contractState?: ExtensionState
  displayText?: boolean
  hasEmptyPlaceholder?: boolean
  isLoading?: boolean
  sx?: SxProps
}
